import {ChallengeBuilderProject, ChallengeBuilderPrompt} from '../../model/project';

export interface ChallengeBuilderState {
  cbProject: ChallengeBuilderProject;
  loading: boolean;
  nextLoading: boolean;
  backLoading: boolean;
  challengeNextValid: boolean;
  prompts: ChallengeBuilderPrompt[];
}

export const initialChallengeBuilderState: ChallengeBuilderState = {
  cbProject: null,
  loading: false,
  nextLoading: false,
  backLoading: false,
  challengeNextValid: false,
  prompts: [],
};
